import Sidebar from '../../components/Common/Sidebar';
import { AgenticAIForumList } from '../../components/_pages/AgenticAIForum';

const AgenticAIForum = () => {
  return (
    <>
      <Sidebar />
      <AgenticAIForumList />
    </>
  );
};

export default AgenticAIForum;
